module.exports = __webpack_public_path__ + "media/images/icons/icons_small/19_ringbox-d5defff4868bf04a5d2ef80acdc99d63.png";